import { useQueryWithUserId } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';
import { IFetchNlStaffUrlOptions } from '../../../types';

/**
 * This is to track the device categories from the backend.
 */
const INBOUND_NL_STAFF_SEARCH_LIST_KEY = 'inbound-nl-staff-list-query';

interface INlSTaffListQuery {
  enabled: boolean;
  queryParams: IFetchNlStaffUrlOptions;
}

/**
 * This hook fetches list of inbound items.
 * TODO: Add proper types.
 */
export const useSearchNlStaffListQuery = ({
  enabled,
  queryParams,
}: INlSTaffListQuery) => {
  const { count, page, search } = queryParams;

  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    enabled,
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [INBOUND_NL_STAFF_SEARCH_LIST_KEY, count, page, search],
    networkMode: 'always',
    queryFn: () => INBOUND_API.fetchAllNlStaffs(queryParams),
  });

  return {
    error,
    isError,
    data,
    isPending,
    refetch,
  };
};
